module.exports = __webpack_public_path__ + "media/images/ecommerce/produc_slider_03-2f14b6618f2adaa3201787128e5e67ac.png";